import { createSelector } from 'reselect';

import { useSliceData } from '@hooks';

import { mobileTimelineState, selectors } from 'components/@main/TimeLineBar/@slices';

const selector = createSelector(selectors.root, (state) => state.mobileTimeline);

export default () => useSliceData(mobileTimelineState, selector);
